// extracted by mini-css-extract-plugin
export var container = "ArInternetExploderModal-module--container--gMcjJ";
export var overlayer = "ArInternetExploderModal-module--overlayer--JGn4t";